import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07a52fc2&scoped=true&"
import script from "./component.js?vue&type=script&lang=js&"
export * from "./component.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=07a52fc2&prod&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=07a52fc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a52fc2",
  null
  
)

export default component.exports